<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <!-- BOC:[error] -->
    <AError
      v-if="api.isError"
      :api="api"
      :callbackReset="() => (api.isError = false)"
    ></AError>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col cols="12" sm="6">
          <h2 v-if="user.name">{{ user.name }}</h2>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="d-flex justify-end">
            <div>
              <v-btn
                rounded
                color="primary"
                :to="{
                  name: 'PageEducatorUserEdit',
                  params: { id: this.$route.params.id },
                }"
                large
              >
                Edit
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-card-title></v-card-title>
      <ALoader :isLoading="api.isLoading"></ALoader>
      <v-tabs
        v-model="tab"
        next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline"
        show-arrows
      >
        <v-tab href="#mission"> Missions </v-tab>
        <v-tab href="#info"> Info </v-tab>
        <!-- <v-tab
          href="#performance"
        >
        Performance
        </v-tab>
        <v-tab href="#activity"> Activity </v-tab> -->
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item class="px-1 py-2" value="info">
          <Read v-if="!api.isLoading" :headers="headers" :data="user" />
        </v-tab-item>
        <v-tab-item class="px-1 py-2" value="performance">
          <v-tabs centered show-arrows>
            <v-tab> {{ $t("view.PagePerformance.performance_table") }} </v-tab>
            <v-tab>{{ $t("view.PagePerformance.performance_chart") }}</v-tab>

            <v-tab-item>
              <div>
                <Performance v-if="!api.isLoading" :mochiId="mochiId" />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="d-flex justify-space-around pt-3" v-if="mochiId">
                <div>
                  <v-btn
                    @click="selectChart('chart2')"
                    :outlined="selectedChart != 'chart2'"
                    color="primary"
                  >
                    Mastered topics: {{ metrics.totalMastered }}
                  </v-btn>
                </div>
                <div>
                  <v-btn
                    @click="selectChart('chart1')"
                    :outlined="selectedChart != 'chart1'"
                    color="primary"
                  >
                    Total Question: {{ metrics.totalQuestion }}
                  </v-btn>
                </div>
                <div>
                  <v-btn
                    @click="selectChart('chart3')"
                    :outlined="selectedChart != 'chart3'"
                    color="primary"
                  >
                    <span v-if="metrics && metrics.totalMastered">
                      Accuracy: {{ metrics.accuracy }}%</span
                    >
                    <span v-else> Accuracy: 0%</span>
                  </v-btn>
                </div>
              </div>
              <div v-if="selectedChart == 'chart1'">
                <Chart1 v-if="mochiId" :mochiId="mochiId"></Chart1>
              </div>
              <div v-if="selectedChart == 'chart2'">
                <Chart2 v-if="mochiId" :mochiId="mochiId"></Chart2>
              </div>
              <div v-if="selectedChart == 'chart3'">
                <Chart3 v-if="mochiId" :mochiId="mochiId"></Chart3>
              </div>
              <div v-if="!mochiId" class="pa-3 text-center">No Data</div>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
        <v-tab-item class="px-1 py-2" value="activity">
          <v-tabs centered show-arrows>
            <v-tab> Table </v-tab>
            <v-tab>Chart</v-tab>

            <v-tab-item>
              <div>
                <Table v-if="mochiId" :mochiId="mochiId" />
              </div>
              <div v-if="!mochiId" class="pa-3 text-center">No Activity</div>
            </v-tab-item>
            <v-tab-item>
              <div class="d-flex justify-space-around pt-3">
                <div @click="selectActivityChart('chart4')">
                  <LastLogin
                    v-if="mochiId"
                    :outlined="selectedActivityChart != 'chart4'"
                    :mochiId="mochiId"
                  ></LastLogin>
                </div>
                <div>
                  <v-btn
                    v-if="mochiId"
                    @click="selectActivityChart('chart5')"
                    :outlined="selectedActivityChart != 'chart5'"
                    color="primary"
                  >
                    Total Hours Spent : 310
                  </v-btn>
                </div>
              </div>
              <div v-if="selectedActivityChart == 'chart4'">
                <Chart4 v-if="mochiId" :mochiId="mochiId"></Chart4>
              </div>
              <div v-if="selectedActivityChart == 'chart5'">
                <Chart5 v-if="mochiId"></Chart5>
              </div>
              <div v-if="!mochiId" class="pa-3 text-center">No Activity</div>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
        <v-tab-item class="px-1 py-2" value="mission">
          <v-row>
            <v-col class="text-right">
              <v-btn
                rounded
                :to="{
                  name: 'PageEducatorUserMissionAdd',
                  params: { parentId: this.$route.params.id },
                }"
                :disabled="!mochiId"
                color="primary"
                large
                class="mr-3"
              >
                + New
              </v-btn>
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="!mochiId"
                    width="100px"
                    rounded
                    large
                    color="green"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Share
                  </v-btn>
                </template>
                <v-list width="180px">
                  <v-list-item>
                    <v-list-item-action class="text-center">
                      <ShareNetwork
                        class="text-decoration-none"
                        network="whatsapp"
                        title="Mission Report"
                        :url="gameUrl"
                      >
                        <v-btn width="150px" rounded color="green" dark>
                          <v-icon left dark> mdi-whatsapp </v-icon>
                          Whatsapp
                        </v-btn>
                      </ShareNetwork>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-btn
                        width="150px"
                        :disabled="copied"
                        @click="onCopy"
                        rounded
                        color="primary"
                      >
                        <v-icon left dark> mdi-content-copy </v-icon>
                        <span v-if="copied">Copied</span>
                        <span v-else>Copy</span>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-card-title></v-card-title>
          <div
            v-if="missionOngoingApi.isError || missionCompletedApi.isError"
            class="text-center red--text text-caption mb-2"
          >
            <div v-if="missionOngoingApi.isError">
              Ongoing: {{ missionOngoingApi.error }}
            </div>
            <div v-if="missionCompletedApi.isError">
              Completed: {{ missionCompletedApi.error }}
            </div>
          </div>
          <div v-if="missionLoading" class="text-center py-4">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-if="!missionLoading && mochiId">
            <v-tabs
              v-model="missionTab"
              background-color="transparent"
              grow
              class="mb-2"
              slider-color="primary"
            >
              <v-tab href="#ongoing">Ongoing</v-tab>
              <v-tab href="#completed">Completed</v-tab>
            </v-tabs>
            <v-tabs-items v-model="missionTab">
              <v-tab-item value="ongoing" class="pt-2">
                <v-simple-table v-if="ongoingMissions.length" dense>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 40px">#</th>
                      <th class="text-left">Question</th>
                      <th class="text-center" style="width: 80px">Grade</th>
                      <th class="text-center" style="width: 120px">Stars</th>
                      <th class="text-center" style="width: 140px">
                        Last Updated
                      </th>
                      <th class="text-center" style="width: 50px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(m, i) in ongoingMissions"
                      :key="m.id || 'o-' + i"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <div class="font-weight-medium">
                          {{ getMissionQuestionName(m) }}
                        </div>
                        <div
                          class="grey--text text--darken-1 text-caption"
                          v-if="m.mathRecord && m.mathRecord.timestampUpdated"
                        >
                          {{
                            $moment(m.mathRecord.timestampUpdated).format(
                              "DD/MM/YY HH:mm"
                            )
                          }}
                        </div>
                      </td>
                      <td class="text-center">
                        <v-img
                          contain
                          max-width="40"
                          max-height="40"
                          :src="gradeImage(m)"
                          class="mx-auto"
                        ></v-img>
                      </td>
                      <td class="text-center">
                        <v-rating
                          :value="m.mathRecord ? m.mathRecord.topStar : 0"
                          length="3"
                          readonly
                          dense
                          background-color="amber"
                          color="amber"
                          size="20"
                        ></v-rating>
                      </td>
                        <td class="text-center">
                        <div
                          v-if="m.mathRecord && m.mathRecord.timestampUpdated"
                        >
                          <div>
                            {{
                              $moment(m.mathRecord.timestampUpdated).format(
                                "DD/MM/YY"
                              )
                            }}
                          </div>
                          <div class="text-caption">
                            {{
                              $moment(m.mathRecord.timestampUpdated).format(
                                "HH:mm"
                              )
                            }}
                          </div>
                        </div>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                        <v-btn
                          icon
                          small
                          :disabled="!m.id"
                          @click="m.id && clickRead(m)"
                          :aria-label="'View mission ' + (i+1)"
                        >
                          <v-icon color="primary">mdi-arrow-right</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div v-else class="text-center py-6 grey--text">
                  No ongoing missions
                </div>
              </v-tab-item>
              <v-tab-item value="completed" class="pt-2">
                <v-simple-table v-if="completedMissions.length" dense>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 40px">#</th>
                      <th class="text-left">Question</th>
                      <th class="text-center" style="width: 80px">Grade</th>
                      <th class="text-center" style="width: 120px">Stars</th>
                      <th class="text-center" style="width: 140px">
                        Last Updated
                      </th>
                      <th class="text-center" style="width: 50px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(m, i) in completedMissions"
                      :key="m.id || 'c-' + i"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <div class="font-weight-medium">
                          {{ getMissionQuestionName(m) }}
                        </div>
                      </td>
                      <td class="text-center">
                        <v-img
                          contain
                          max-width="40"
                          max-height="40"
                          :src="gradeImage(m)"
                          class="mx-auto"
                        ></v-img>
                      </td>
                      <td class="text-center">
                        <v-rating
                          :value="m.mathRecord ? m.mathRecord.topStar : 0"
                          length="3"
                          readonly
                          dense
                          background-color="amber"
                          color="amber"
                          size="20"
                        ></v-rating>
                      </td>
                      <td class="text-center">
                        <div
                          v-if="m.mathRecord && m.mathRecord.timestampUpdated"
                        >
                          <div>
                            {{
                              $moment(m.mathRecord.timestampUpdated).format(
                                "DD/MM/YY"
                              )
                            }}
                          </div>
                          <div class="text-caption">
                            {{
                              $moment(m.mathRecord.timestampUpdated).format(
                                "HH:mm"
                              )
                            }}
                          </div>
                        </div>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                        <v-btn
                          icon
                          small
                          :disabled="!m.id"
                          @click="m.id && clickRead(m)"
                          :aria-label="'View mission ' + (i+1)"
                        >
                          <v-icon color="primary">mdi-arrow-right</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div v-else class="text-center py-6 grey--text">
                  No completed missions
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
          <div class="text-center" v-if="!mochiId && !api.isLoading">
            <p>Mochi not found</p>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import Read from "../../components/Datatable/Read.vue";
import Performance from "../../components/Datatable/Performance.vue";
import Chart1 from "../../components/Performance/Chart1.vue";
import Chart2 from "../../components/Performance/Chart2.vue";
import Chart3 from "../../components/Performance/Chart3.vue";
import Chart4 from "../../components/Activity/Chart4.vue";
import Chart5 from "../../components/Activity/Chart5.vue";
import Table from "../../components/Activity/Table.vue";
import LastLogin from "../../components/Activity/Metrics/LastLogin.vue";
export default {
  components: {
    Read,
    Performance,
    Chart1,
    Chart2,
    Chart3,
    Chart4,
    Chart5,
    Table,
    LastLogin,
  },
  computed: {
    missionLoading() {
      return (
        this.missionOngoingApi.isLoading || this.missionCompletedApi.isLoading
      );
    },
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    metrics: {},
    mochiId: null,
    tab: null,
    copied: false,
    gameUrl: null,
    whatsappUrl: null,
    missionBaseUrl: null,
    missionOngoingApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    missionCompletedApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    ongoingMissions: [],
    completedMissions: [],
    missionTab: "ongoing",
    questionsData: [],
    questionsMap: {},
    gradeShields: {
      A: require("@/assets/math/shields/gradeA.png"),
      B: require("@/assets/math/shields/gradeB.png"),
      C: require("@/assets/math/shields/gradeC.png"),
      F: require("@/assets/math/shields/gradeF.png"),
      X: require("@/assets/math/shields/gradeX.png"),
    },
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    metricsApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    playerApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    totalPage: 0,
    search: "",
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Name", value: "name" },
      { text: "Mochi Id", value: "mochiId" },
      { text: "Type of Account", value: "userType" },
      { text: "Date of Birth", value: "dateOfBirth" },
      { text: "Gender", value: "gender" },
      { text: "Race", value: "race" },
      { text: "NRIC/Passport Number", value: "moeNumber" },
      { text: "Email Address", value: "email" },
      { text: "School Name", value: "mainInstitution" },
      { text: "Classroom Name", value: "mainClassroom" },
      { text: "State", value: "state" },
      { text: "Last Update", value: "timestampUpdated" },
    ],
    user: {},
  }),
  created() {
    this.api.method = "GET";
    this.api.url =
      this.$api.servers.sso +
      "/api/v2/" +
      this.$_getLocale() +
      "/backend/user/" +
      this.$route.params.id;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.user = resp;
      this.updateBreadcrumb(resp);
    };
    this.playerApi.method = "GET";
    this.playerApi.url =
      this.$api.servers.game +
      "/api/v1/" +
      this.$_getLocale() +
      "/user/" +
      this.$route.params.id +
      "/player";
    this.playerApi.callbackReset = () => {
      this.playerApi.isLoading = true;
      this.playerApi.isError = false;
    };
    this.playerApi.callbackError = (e) => {
      this.playerApi.isLoading = false;
      this.playerApi.isError = true;
      this.playerApi.error = e;
    };
    this.playerApi.callbackSuccess = (resp) => {
      this.playerApi.isLoading = false;
      this.mochiId = resp.mochiId || null;
      this.user.mochiId = resp.mochiId || null;
      if (this.mochiId) {
        this.missionBaseUrl =
          this.$api.servers.game +
          "/api/v1/" +
          this.$_getLocale() +
          "/backend/player/" +
          this.mochiId +
          "/mission";
        this.missionOngoingApi.url = this.missionBaseUrl + "/ongoing";
        this.missionCompletedApi.url = this.missionBaseUrl + "/completed";
        this.fetchOngoingMissions();
        this.fetchCompletedMissions();
        this.gameUrl = `${process.env.VUE_APP_URL_WEB_SCHOOL}/en/mission/${this.mochiId}`;
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.whatsappUrl =
            "https://api.whatsapp.com/send?text=" + this.gameUrl;
        } else {
          this.whatsappUrl =
            "https://web.whatsapp.com/send?l=en&text=" + this.gameUrl;
        }
      }
      this.getPerformanceMetrics();
    };
  },
  mounted() {
    this.$api.fetch(this.api);
    this.$api.fetch(this.playerApi);
  },
  methods: {
    updateBreadcrumb(resp) {
      this.breadcrumbs.push({
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      });
      this.breadcrumbs.push({
        text: resp.name,
        to: { name: "PageEducatorUserRead" },
        exact: true,
      });
    },
    clickRead(item) {
      this.$router.push({
        name: "PageEducatorUserMissionRead",
        params: { parentId: this.$route.params.id, id: item.id },
      });
    },
    onCopy() {
      navigator.clipboard.writeText(this.gameUrl);
      this.copied = true;
      var self = this;
      setTimeout(() => {
        if (self && self.copied) self.copied = false;
      }, 800);
    },
    fetchOngoingMissions() {
      if (!this.missionOngoingApi.url) return;
      this.missionOngoingApi.method = "GET";
      this.missionOngoingApi.callbackReset = () => {
        this.missionOngoingApi.isLoading = true;
        this.missionOngoingApi.isError = false;
      };
      this.missionOngoingApi.callbackError = (e) => {
        this.missionOngoingApi.isLoading = false;
        this.missionOngoingApi.isError = true;
        this.missionOngoingApi.error = e;
      };
      this.missionOngoingApi.callbackSuccess = (resp) => {
        this.missionOngoingApi.isLoading = false;
        this.ongoingMissions = Array.isArray(resp)
          ? resp
          : (resp && resp.items) || [];
        this.fetchQuestionsForMissions(this.ongoingMissions);
      };
      this.$api.fetch(this.missionOngoingApi);
    },
    fetchCompletedMissions() {
      if (!this.missionCompletedApi.url) return;
      this.missionCompletedApi.method = "GET";
      this.missionCompletedApi.callbackReset = () => {
        this.missionCompletedApi.isLoading = true;
        this.missionCompletedApi.isError = false;
      };
      this.missionCompletedApi.callbackError = (e) => {
        this.missionCompletedApi.isLoading = false;
        this.missionCompletedApi.isError = true;
        this.missionCompletedApi.error = e;
      };
      this.missionCompletedApi.callbackSuccess = (resp) => {
        this.missionCompletedApi.isLoading = false;
        this.completedMissions = Array.isArray(resp)
          ? resp
          : (resp && resp.items) || [];
        this.fetchQuestionsForMissions(this.completedMissions);
      };
      this.$api.fetch(this.missionCompletedApi);
    },
    gradeImage(mission) {
      const grade = mission && mission.mathRecord && mission.mathRecord.grade;
      return this.gradeShields[grade] || this.gradeShields.X;
    },
    getMissionQuestionName(mission) {
      if (!mission) return "-";
      const key =
        mission.questionKey ||
        mission.question_key ||
        (mission.mathRecord && (mission.mathRecord.questionKey || mission.mathRecord.question_key));
      if (mission.questionName) return mission.questionName;
      if (mission.mathRecord && mission.mathRecord.questionName)
        return mission.mathRecord.questionName;
      if (key && this.questionsMap[key]) {
        const q = this.questionsMap[key];
        return q.name || q.questionName || key;
      }
      return key || "-";
    },
    async fetchQuestionsForMissions(list) {
      if (!Array.isArray(list) || !list.length) return;
      const keys = [
        ...new Set(
          list
            .map(
              (m) =>
                m.questionKey ||
                m.question_key ||
                (m.mathRecord && (m.mathRecord.questionKey || m.mathRecord.question_key))
            )
            .filter((k) => k && !this.questionsMap[k])
        ),
      ];
      for (const k of keys) {
        await this.fetchSingleQuestion(k);
      }
    },
    async fetchSingleQuestion(questionKey) {
      if (!questionKey || this.questionsMap[questionKey]) return;
      const apiQuestion = {
        method: "post",
        url: `${process.env.VUE_APP_URL_API_QUESTION}/v2/questions`,
        isLoading: false,
        isError: false,
        error: null,
      };
      apiQuestion.callbackReset = () => {
        apiQuestion.isLoading = true;
        apiQuestion.isError = false;
      };
      apiQuestion.callbackError = (e) => {
        apiQuestion.isLoading = false;
        apiQuestion.isError = true;
        apiQuestion.error = e;
      };
      apiQuestion.callbackSuccess = (resp) => {
        apiQuestion.isLoading = false;
        if (resp && resp.length) {
          const q = resp[0];
          const k = q.key || q.questionKey || questionKey;
          if (!this.questionsMap[k]) {
            this.questionsData.push(q);
            this.$set(this.questionsMap, k, q);
          }
        }
      };
      apiQuestion.params = {
        key: questionKey,
        lang: this.$_getLocale(),
        count: 1,
        showOption: false,
      };
      await this.$api.fetch(apiQuestion);
    },
    selectChart(value) {
      this.selectedChart = value;
    },
    selectActivityChart(value) {
      this.selectedActivityChart = value;
    },
    getPerformanceMetrics() {
      this.metricsApi.url =
        this.$api.servers.log +
        "/api/v1/" +
        this.$_getLocale() +
        "/performance/player/" +
        this.mochiId +
        "/metrics";
      this.metricsApi.callbackReset = () => {
        this.metricsApi.isLoading = true;
        this.metricsApi.isError = false;
      };
      this.metricsApi.callbackError = (e) => {
        this.metricsApi.isLoading = false;
        this.metricsApi.isError = true;
        this.metricsApi.error = e;
      };
      this.metricsApi.callbackSuccess = (resp) => {
        this.metricsApi.isLoading = false;
        this.metrics = resp;
      };
      this.$api.fetch(this.metricsApi);
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>